'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var postJobController = function () {
  function postJobController(UsersService, NotificationService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, postJobController);
    this.usersService = UsersService;
    this.notificationService = NotificationService;
    this.jobCountOptions = [50, 100, 150];
    this.selectedJobCount = null;
    this.manualJobCount = null;
    this.isLoading = false;
  }

  (0, _createClass3.default)(postJobController, [{
    key: 'addJobs',
    value: function addJobs() {
      var _this = this;

      var count = this.selectedJobCount === 'manual' ? this.manualJobCount : this.selectedJobCount;
      if (!count || count <= 0) return;

      this.isLoading = true;
      this.usersService.updateJobPostLimit(this.user.userId, count, function (response) {
        _this.user.clientInfo.jobPostLimit = response.data;
        _this.selectedJobCount = null;
        _this.manualJobCount = null;
        _this.isLoading = false;
        _this.notificationService.success('Job post limit updated successfully.');
      }, function (error) {
        _this.isLoading = false;
        _this.notificationService.error('Failed to update job post limit.');
      });
    }
  }]);
  return postJobController;
}();

exports.default = postJobController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/post-job/post-job.controller.js
 **/